import React from 'react';
import { useSelector } from 'react-redux';

import Image from '../Generic/Image/Image';

const BrandLogo = ({ Brand, BrandUrl, customCatSmall }) => {
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	if (Brand === 'Apple') {
		return null;
	}

	if (!BrandUrl) {
		return null;
	}

	return (
		<Image
			src={BrandUrl}
			alt={`${Brand} Logo`}
			classes={`inline-block ${customCatSmall ? 'mb-1' : 'mb-4'}`}
			style={{
				maxHeight: CustomCategoriesEnabled ? '24px' : '40px',
				maxWidth: '100px',
			}}
			skeletonProps={{ height: CustomCategoriesEnabled ? '24px' : '40px' }}
			errorSize="small"
		/>
	);
};

export default BrandLogo;
